var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveLogM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 209,
    viewBox: "0 0 320 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-35.847 431.439C-136.039 355.823 -77.5197 189.292 18.904 138.29C55.0352 119.22 97.1513 111.903 137.716 117.224C174.29 122.103 219.953 134.521 257.414 120.329C285.787 109.463 298.865 82.6321 313.717 58.24C354.946 -9.61432 458.907 -22.2539 510.554 42.0525C529.617 65.7794 537.375 98.8195 528.066 127.868C506.121 195.279 432.529 166.452 390.856 202.597C374.231 217.01 369.798 245.837 360.044 265.129C350.07 284.865 337.878 303.713 324.8 321.674C297.314 359.593 263.842 394.185 225.273 421.017C148.356 474.679 52.1536 490.645 -29.197 436.317C-31.4137 434.765 -33.6304 433.213 -35.847 431.439Z",
    fill: "url(#paint0_radial_201_1108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_201_1108",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.949 37.4663) rotate(-122.473) scale(729.916 1226.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogM);
export default __webpack_public_path__ + "static/media/waveLog_m.7e55a73c26c6682b222beac84520e578.svg";
export { ForwardRef as ReactComponent };